export const COOKIE_NAME = 'url_shortener_fkam_dashboard'
export const COOKIE_NAME_API = 'some_req_shortener'